// frontend/src/constants/voices.ts

export interface VoiceOption {
  name: string;
  id: string;
  type: 'neural2' | 'wavenet' | 'standard';
}

export const VOICE_OPTIONS: VoiceOption[] = [
  // ═══════════════════════════════════════════════════════
  // ENGLISH (US) - Neural2 (Highest Quality)
  // ═══════════════════════════════════════════════════════
  { name: "Neural2-A (Male)", id: "en-US-Neural2-A", type: "neural2" },
  { name: "Neural2-C (Female)", id: "en-US-Neural2-C", type: "neural2" },
  { name: "Neural2-D (Male)", id: "en-US-Neural2-D", type: "neural2" },
  { name: "Neural2-E (Female)", id: "en-US-Neural2-E", type: "neural2" },
  { name: "Neural2-F (Female)", id: "en-US-Neural2-F", type: "neural2" },
  { name: "Neural2-G (Female)", id: "en-US-Neural2-G", type: "neural2" },
  { name: "Neural2-H (Female)", id: "en-US-Neural2-H", type: "neural2" },
  { name: "Neural2-I (Male)", id: "en-US-Neural2-I", type: "neural2" },
  { name: "Neural2-J (Male)", id: "en-US-Neural2-J", type: "neural2" },

  // ═══════════════════════════════════════════════════════
  // ENGLISH (US) - WaveNet
  // ═══════════════════════════════════════════════════════
  { name: "Wavenet-A (Male)", id: "en-US-Wavenet-A", type: "wavenet" },
  { name: "Wavenet-B (Male)", id: "en-US-Wavenet-B", type: "wavenet" },
  { name: "Wavenet-C (Female)", id: "en-US-Wavenet-C", type: "wavenet" },
  { name: "Wavenet-D (Male)", id: "en-US-Wavenet-D", type: "wavenet" },
  { name: "Wavenet-E (Female)", id: "en-US-Wavenet-E", type: "wavenet" },
  { name: "Wavenet-F (Female)", id: "en-US-Wavenet-F", type: "wavenet" },

  // ═══════════════════════════════════════════════════════
  // ENGLISH (US) - Standard
  // ═══════════════════════════════════════════════════════
  { name: "Standard-B (Male)", id: "en-US-Standard-B", type: "standard" },
  { name: "Standard-C (Female)", id: "en-US-Standard-C", type: "standard" },

  // ═══════════════════════════════════════════════════════
  // FRENCH (France) - Neural2
  // ═══════════════════════════════════════════════════════
  { name: "Français Neural2-A (Female)", id: "fr-FR-Neural2-A", type: "neural2" },
  { name: "Français Neural2-B (Male)", id: "fr-FR-Neural2-B", type: "neural2" },
  { name: "Français Neural2-C (Female)", id: "fr-FR-Neural2-C", type: "neural2" },
  { name: "Français Neural2-D (Male)", id: "fr-FR-Neural2-D", type: "neural2" },
  { name: "Français Neural2-E (Female)", id: "fr-FR-Neural2-E", type: "neural2" },

  // ═══════════════════════════════════════════════════════
  // FRENCH (France) - WaveNet
  // ═══════════════════════════════════════════════════════
  { name: "Français Wavenet-A (Female)", id: "fr-FR-Wavenet-A", type: "wavenet" },
  { name: "Français Wavenet-B (Male)", id: "fr-FR-Wavenet-B", type: "wavenet" },
  { name: "Français Wavenet-C (Female)", id: "fr-FR-Wavenet-C", type: "wavenet" },
  { name: "Français Wavenet-D (Male)", id: "fr-FR-Wavenet-D", type: "wavenet" },

  // ═══════════════════════════════════════════════════════
  // FRENCH (France) - Standard
  // ═══════════════════════════════════════════════════════
  { name: "Français Standard-A (Female)", id: "fr-FR-Standard-A", type: "standard" },
  { name: "Français Standard-B (Male)", id: "fr-FR-Standard-B", type: "standard" },
  { name: "Français Standard-C (Female)", id: "fr-FR-Standard-C", type: "standard" },
  { name: "Français Standard-D (Male)", id: "fr-FR-Standard-D", type: "standard" },

  // ═══════════════════════════════════════════════════════
  // FRENCH (Canada) - Neural2
  // ═══════════════════════════════════════════════════════
  { name: "Français (CA) Neural2-A (Female)", id: "fr-CA-Neural2-A", type: "neural2" },
  { name: "Français (CA) Neural2-B (Male)", id: "fr-CA-Neural2-B", type: "neural2" },
  { name: "Français (CA) Neural2-C (Female)", id: "fr-CA-Neural2-C", type: "neural2" },
  { name: "Français (CA) Neural2-D (Male)", id: "fr-CA-Neural2-D", type: "neural2" },

  // ═══════════════════════════════════════════════════════
  // FRENCH (Canada) - WaveNet
  // ═══════════════════════════════════════════════════════
  { name: "Français (CA) Wavenet-A (Female)", id: "fr-CA-Wavenet-A", type: "wavenet" },
  { name: "Français (CA) Wavenet-B (Male)", id: "fr-CA-Wavenet-B", type: "wavenet" },

  // ═══════════════════════════════════════════════════════
  // FRENCH (Canada) - Standard
  // ═══════════════════════════════════════════════════════
  { name: "Français (CA) Standard-A (Female)", id: "fr-CA-Standard-A", type: "standard" },
  { name: "Français (CA) Standard-B (Male)", id: "fr-CA-Standard-B", type: "standard" },
];

// ═══════════════════════════════════════════════════════
// GROUPED OPTIONS FOR BETTER UX
// ═══════════════════════════════════════════════════════

export const VOICE_OPTIONS_GROUPED = {
  neural2: VOICE_OPTIONS.filter(v => v.type === 'neural2'),
  wavenet: VOICE_OPTIONS.filter(v => v.type === 'wavenet'),
  standard: VOICE_OPTIONS.filter(v => v.type === 'standard'),
};

export interface VoiceOptGroup {
  label: string;
  options: VoiceOption[];
  badge?: string;
  description?: string;
}

export function getVoiceOptGroups(): VoiceOptGroup[] {
  return [
    {
      label: 'Neural2 (Natural Quality)',
      options: VOICE_OPTIONS.filter(v => v.type === 'neural2'),
      badge: 'BEST',
      description: 'Most natural and expressive voices',
    },
    {
      label: 'WaveNet (High Quality)',
      options: VOICE_OPTIONS.filter(v => v.type === 'wavenet'),
      description: 'High quality synthetic voices',
    },
    {
      label: 'Standard',
      options: VOICE_OPTIONS.filter(v => v.type === 'standard'),
      description: 'Reliable synthetic voices',
    },
  ];
}

// ═══════════════════════════════════════════════════════
// PLAN-BASED VOICE FILTERING
// ═══════════════════════════════════════════════════════

/**
 * Filter voices by user plan
 * - Free: Standard voices only
 * - Starter: WaveNet + Standard voices
 * - Pro: All voices (Neural2 + WaveNet + Standard)
 */
export function getVoicesByPlan(plan: 'free' | 'starter' | 'pro'): VoiceOption[] {
  if (plan === 'pro') {
    // Pro gets everything
    return VOICE_OPTIONS;
  }

  if (plan === 'starter') {
    // Starter gets WaveNet + Standard
    return VOICE_OPTIONS.filter(v => v.type === 'wavenet' || v.type === 'standard');
  }

  // Free gets Standard only
  return VOICE_OPTIONS.filter(v => v.type === 'standard');
}

/**
 * Get grouped voice options filtered by user plan
 * Adds locked badges to unavailable tiers
 */
export function getVoiceOptGroupsByPlan(plan: 'free' | 'starter' | 'pro'): VoiceOptGroup[] {
  const allowedVoices = getVoicesByPlan(plan);
  const allowedTypes = new Set(allowedVoices.map(v => v.type));

  const allGroups = getVoiceOptGroups();

  return allGroups.map(group => {
    const groupType = group.options[0]?.type as 'neural2' | 'wavenet' | 'standard';
    const isLocked = !allowedTypes.has(groupType);

    return {
      ...group,
      // Filter to only show allowed voices
      options: group.options.filter(voice =>
        allowedVoices.some(allowed => allowed.id === voice.id)
      ),
      // Add locked badge for unavailable tiers
      badge: isLocked ? '🔒 UPGRADE' : group.badge,
      // Update description for locked tiers
      description: isLocked
        ? `Upgrade to ${plan === 'free' ? 'Starter or Pro' : 'Pro'} to unlock`
        : group.description,
    };
  });
}

// ═══════════════════════════════════════════════════════
// HELPER FUNCTIONS
// ═══════════════════════════════════════════════════════

// Helper to get voice type for a given voice ID
export function getVoiceType(voiceId: string): 'neural2' | 'wavenet' | 'standard' | null {
  const voice = VOICE_OPTIONS.find(v => v.id === voiceId);
  return voice?.type ?? null;
}

// Helper to get voice name for a given voice ID
export function getVoiceName(voiceId: string): string | null {
  const voice = VOICE_OPTIONS.find(v => v.id === voiceId);
  return voice?.name ?? null;
}

// Helper to check if a voice is available for a plan
export function isVoiceAvailableForPlan(voiceId: string, plan: 'free' | 'starter' | 'pro'): boolean {
  const allowedVoices = getVoicesByPlan(plan);
  return allowedVoices.some(v => v.id === voiceId);
}

// Helper to get the minimum plan required for a voice
export function getMinimumPlanForVoice(voiceId: string): 'free' | 'starter' | 'pro' {
  const voiceType = getVoiceType(voiceId);

  if (voiceType === 'neural2') return 'pro';
  if (voiceType === 'wavenet') return 'starter';
  return 'free';
}